<p
  *ngIf="star"
  class="inline block text-sm text-neutral-600"
>
  <i class="icon icon-star text-xs mr-0.5 text-highlight-500"></i>
  <span>{{ star }}</span>
</p>
